import { Pipe, PipeTransform } from '@angular/core';
import { arrayEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'findInListById',
    standalone: false
})
export class FindInListByIdPipe implements PipeTransform {

    transform(value: number | string, list: Record<string, any>[], idKey = 'Id'): Record<string, any> {
        if (!value || arrayEmpty(list)) {
            return null;
        }

        return list.find(e => e?.[idKey] === value);
    }

}
